<template>
  <div>
    <div id="tooltipApexChart" class="custom-tooltip-apexchart"></div>
    <table-ag
      ref="agCult"
      :row-data="datos.filter((e) => e.nombre !== 'null')"
      :columnDefs="columns"
      :menu-filter="{ group: 'grupo', active: true }"
      :typeSelection="limitSelection === 2 ? 'multiple' : 'single'"
      :limitSelection="limitSelection"
      :onDeselectEmptyData="true"
      @selected="selected"
    ></table-ag>
  </div>
</template>

<script>
import tableAg from "../dashboard/tableAg.vue";
export default {
  data() {
    return {
      columns: [
        {
          field: "grupo",
          hide: true,
          editable: false,
          getQuickFilterText: (params) => {
            return `FILTER_${params.value.replace(" ", "")}_GRUPO`;
          },
        },
        {
          field: "nombre",
          headerName: "SubGrupo",
          filter: "agTextColumnFilter",
          editable: false,
          resizable: true,
          checkboxSelection: true,
          showDisabledCheckboxes: true,
        },
        {
          field: "ClanM_hoy",
          headerName: "Clan",
          valueGetter: (params) => {
            return params.data[params.colDef.field].p;
          },
          width: 250,
          cellRenderer: "graphTable",
          filter: "agTextColumnFilter",
          editable: false,
          resizable: true,
          autoHeight: true,
          getQuickFilterText: (params) => {
            return "";
          },
        },
        {
          field: "Adhocraciam_hoy",
          headerName: "Adhocrática",
          valueGetter: (params) => {
            return params.data[params.colDef.field].p;
          },
          width: 250,
          cellRenderer: "graphTable",
          filter: "agTextColumnFilter",
          editable: false,
          resizable: true,
          autoHeight: true,
          getQuickFilterText: (params) => {
            return "";
          },
        },
        {
          field: "Jerarquicam_hoy",
          headerName: "Jerárquica",
          valueGetter: (params) => {
            return params.data[params.colDef.field].p;
          },
          width: 250,
          cellRenderer: "graphTable",
          filter: "agTextColumnFilter",
          editable: false,
          resizable: true,
          autoHeight: true,
          getQuickFilterText: (params) => {
            return "";
          },
        },
        {
          field: "Mercadodm_hoy",
          headerName: "Mercado",
          filter: "agTextColumnFilter",
          cellRenderer: "graphTable",
          valueGetter: (params) => {
            return params.data[params.colDef.field].p;
          },
          width: 250,
          editable: false,
          resizable: true,
          autoHeight: true,
          getQuickFilterText: (params) => {
            return "";
          },
        },
      ],
    };
  },
  props: {
    datos: Array,
    filters: {
      type: String,
      default() {
        return null;
      },
    },
    limitSelection: {
      type: Number,
      default() {
        return 1;
      },
    },
  },
  methods: {
    // Actions
    selected(i) {
      this.$emit("setFilterTable", i);
    },
    deselect() {
      this.$refs.agCult.deselectAll();
    },
  },
  created() {},
  components: {
    tableAg,
  },
};
</script>
<style lang="scss">
// Range 2
.bg-altaTable {
  background-color: #f4cdcd;
  border: solid 1px #f6adad;
}
.bg-mediaTable {
  background-color: #fff2cc;
  border: solid 1px #f6db8a;
}
.bg-destacadoTable {
  background-color: #d9ead3;
  border: solid 1px #c3eab5;
}
.bg-sinrangoTable {
  background-color: #eceeec;
  border: solid 1px #d4d5d3;
}

.custom-tooltip-apexchart {
  position: absolute;
  background-color: white;
  color: #333; /* Color de texto */
  border: 1px solid #ccc;
  padding: 10px;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2); /* Sombras */
  z-index: 9999;
  font-family: Arial, sans-serif; /* Fuente del texto */
  display: none;
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/cultura/tableGroupsResult.vue